var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',{attrs:{"time":_vm.value}},[(_vm.date)?[_vm._v(_vm._s(_vm._f("dateFormat")(_vm.aMoment,_vm.format)))]:[_vm._v(_vm._s(_vm._f("dateTimeFormat")(_vm.aMoment,_vm.format)))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }